import React from 'react';
import { Box, keyframes } from '@mui/material';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  variant?: 'spinner' | 'pulse' | 'dots';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 20, 
  color = '#8b5cf6',
  variant = 'spinner'
}) => {
  if (variant === 'spinner') {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          border: `2px solid ${color}20`,
          borderTop: `2px solid ${color}`,
          borderRadius: '50%',
          animation: `${spin} 1s linear infinite`,
        }}
      />
    );
  }

  if (variant === 'pulse') {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          backgroundColor: color,
          borderRadius: '50%',
          animation: `${pulse} 1.5s ease-in-out infinite`,
        }}
      />
    );
  }

  if (variant === 'dots') {
    return (
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        {[0, 1, 2].map((index) => (
          <Box
            key={index}
            sx={{
              width: size / 3,
              height: size / 3,
              backgroundColor: color,
              borderRadius: '50%',
              animation: `${pulse} 1.4s ease-in-out infinite`,
              animationDelay: `${index * 0.2}s`,
            }}
          />
        ))}
      </Box>
    );
  }

  return null;
};

export default LoadingSpinner;
